/* eslint-disable import/no-cycle */
import {
	setCustomer,
	clear
} from './actions';
import {
	thunkSetCustomerName
} from './thunks';

export {
	setCustomer,
	clear,
	thunkSetCustomerName,
};
